import { Page } from '@/core/architecture'

import { ConsoleCryptocurrencyWalletTemplate } from './template'
import { useViewModel } from './viewModel'

export const ConsoleCryptocurrencyWallet: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCryptocurrencyWalletTemplate state={state} {...actions} />
}
